import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import legalConfig from '../lib/legalConfig';
import { openCookieSettings } from './CookieConsent';
import './Footer.css';

export default function Footer() {
  const { t } = useLanguage();

  return (
    <footer className="footer">
      <div className="footer__inner">
        <div className="footer__top">

          <div className="footer__brand">
            <div className="footer__logo">Cosmo<span>Estates</span></div>
            <p className="footer__tagline">{t('footer.tagline')}</p>
          </div>

          <div className="footer__col">
            <h4>{t('footer.findYourHome')}</h4>
            <Link to="/listings?type=sale&propertyType=house">{t('footer.housesForSale')}</Link>
            <Link to="/listings?type=sale&propertyType=apartment">{t('footer.apartments')}</Link>
            <Link to="/listings?type=sale&propertyType=villa">{t('footer.villas')}</Link>
            <Link to="/listings?type=rent">{t('footer.forRent')}</Link>
          </div>

          <div className="footer__col">
            <h4>{t('footer.services')}</h4>
            <Link to="/valuation">{t('footer.propertyValuation')}</Link>
            <Link to="/renovation">{t('footer.renovationSimulator')}</Link>
            <Link to="/neighbourhood">{t('footer.neighbourhoodIntel')}</Link>
            <Link to="/list-property">{t('footer.listAProperty')}</Link>
            <Link to="/find-agent?apply=1">{t('footer.joinAsAgent')}</Link>
          </div>

          <div className="footer__col">
            <h4>{t('footer.company')}</h4>
            <Link to="/about">{t('footer.whoWeAre')}</Link>
            <Link to="/contact">{t('footer.contactUs')}</Link>
            <Link to="/faq">{t('footer.faq')}</Link>
          </div>

          <div className="footer__col">
            <h4>{t('footer.legal')}</h4>
            <Link to="/terms">{t('footer.terms')}</Link>
            <Link to="/privacy">{t('footer.privacy')}</Link>
            <Link to="/cookies">{t('footer.cookies')}</Link>
            <Link to="/disclaimer">{t('footer.disclaimer')}</Link>
            <Link to="/acceptable-use">{t('footer.acceptableUse')}</Link>
            <Link to="/billing">{t('footer.billingRefunds')}</Link>
            <button
              type="button"
              className="footer__link"
              onClick={openCookieSettings}
            >
              {t('footer.manageCookies')}
            </button>
          </div>

        </div>

        <div className="footer__company" aria-label="Contact information">
          <p>
            <a href={`mailto:${legalConfig.contactEmail}`}>{legalConfig.contactEmail}</a>
          </p>
        </div>

        <div className="footer__bottom">
          <div className="footer__copy">{t('footer.copyright')}</div>
        </div>
      </div>
    </footer>
  );
}
